/**
 * Connector logos, with a graceful fallback.
 *
 * Manifest logos are remote favicons and some will fail to load or be blocked.
 * A tinted monogram is a better outcome than a broken image icon, and it is
 * deterministic so the same connector always looks the same.
 */

const PALETTE = [
  '#2f6feb',
  '#8250df',
  '#1a7f37',
  '#bf3989',
  '#9a6700',
  '#0969da',
  '#cf222e',
  '#116329',
]

export function monogram(name: string): string {
  const words = name.trim().split(/\s+/)
  if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase()
  return name.slice(0, 2).toUpperCase()
}

export function colorFor(id: string): string {
  let hash = 0
  for (let i = 0; i < id.length; i++) hash = (hash * 31 + id.charCodeAt(i)) >>> 0
  return PALETTE[hash % PALETTE.length]
}
